export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-line bg-coal" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center py-4">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-fog sm:text-base">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-steel" />
          </span>
        ))}
      </div>
    </div>
  );
}
